import axios from 'axios';
import { getVaultData } from '../api'; // Adjust path if needed
/* global Autodesk */

let viewer = null;
let svfUrls = {}; // <-- This is your global variable
let vaultFound = null; // Tracks whether GetVaultData found the part
let stpUrl = '';
let activeButton = null;
let data = []; // normalized files array from API

// Route all client traffic through the primary web server using a reverse proxy.
// Configure your web server to proxy `/vault` to `https://hcvault.hamiltoncaster.local:4433`.
// Example targets (for reference only):
//   /vault/api/*   -> https://hcvault.hamiltoncaster.local:4433/api/*
//   /vault/VaultFiles/* -> https://hcvault.hamiltoncaster.local:4433/VaultFiles/*
const VAULT_PROXY_BASE = '/vault';

async function loadVaultData(partId) {
  try {
    const payload = await getVaultData(partId);
    const files = Array.isArray(payload)
      ? payload
      : (payload && Array.isArray(payload.Files) ? payload.Files : []);

    if (payload && payload.Found === false) {
      // Quiet notice: log and keep UI calm
      console.warn('Vault data not found for PartID:', partId);
    }

    data = files || [];
    // Determine found status: prefer explicit Found flag; fallback to files presence
    const hasFoundFlag = payload && Object.prototype.hasOwnProperty.call(payload, 'Found');
    vaultFound = hasFoundFlag ? !!payload.Found : (Array.isArray(data) && data.length > 0);
    
// ✅ PREPARE STEP FOR BASE PART (matches option behavior)
if (Array.isArray(data) && data.length >= 2) {
  // Base part uses the first STEP + first viewable pair
  ViewerModule.getAndDownloadFiles(0, 1);
}

  } catch (err) {
    console.error('Failed to load vault data:', err);
    // ...removed CADTiming log...
    data = [];
    vaultFound = false;
  }
}

const ViewerModule = {
  svfUrls, // expose as property
  get vaultFound() { return vaultFound; },
  loadVaultData,
  reset() {
    try {
      // Attempt to unload any currently visible models
      if (viewer) {
        if (typeof viewer.getVisibleModels === 'function') {
          const models = viewer.getVisibleModels();
          if (models && models.length && typeof viewer.unloadModel === 'function') {
            models.forEach(m => {
              try { viewer.unloadModel(m); } catch (e) { console.warn('Failed to unload model', e); }
            });
          } else if (viewer.impl && typeof viewer.impl.unloadCurrentModel === 'function') {
            try { viewer.impl.unloadCurrentModel(); } catch (e) { console.warn('Failed to unload current model', e); }
          }
        } else if (viewer.impl && typeof viewer.impl.unloadCurrentModel === 'function') {
          try { viewer.impl.unloadCurrentModel(); } catch (e) { console.warn('Failed to unload current model', e); }
        }
      }
    } catch (e) {
      console.warn('Viewer reset: unload exception', e);
    }
    // Clear cached URLs and state
    svfUrls = {};
    stpUrl = '';
    activeButton = null;
    data = [];
    ViewerModule.svfUrls = svfUrls;
    vaultFound = null;
  },
  initializeViewer() {
  return new Promise((resolve) => {
    const viewerDiv = document.getElementById('viewerContainer');
    if (!viewerDiv || !(viewerDiv instanceof HTMLElement)) {
      console.error('viewerContainer not found or is not a valid HTML element!', viewerDiv);
      resolve(false);
      return;
    }
    viewer = new Autodesk.Viewing.GuiViewer3D(viewerDiv);
    const options = {
      env: 'Local',
      getAccessToken: (onSuccess) => onSuccess('', 3600)
    };
    Autodesk.Viewing.Initializer(options, () => {
      const privateLogger = Autodesk && Autodesk.Viewing && Autodesk.Viewing.Private && Autodesk.Viewing.Private.logger;
      const logLevels = Autodesk && Autodesk.Viewing && Autodesk.Viewing.Private && Autodesk.Viewing.Private.LogLevels;
      if (privateLogger && logLevels && typeof privateLogger.setLevel === 'function' && typeof logLevels.ERROR !== 'undefined') {
        privateLogger.setLevel(logLevels.ERROR);
      }
      viewer.start();
      viewer.setEnvMapBackground(true);
      viewer.setLightPreset(0);
      //viewer.setTheme('light');
      resolve(true); // <-- Resolve when done
    });
  });
},

  async showViewer() {
    const staticImage = document.getElementById('staticImageContainer');
    const viewerDiv = document.getElementById('viewerContainer');
    if (staticImage) staticImage.style.display = 'none';
    if (viewerDiv) viewerDiv.style.display = 'flex';

    if (!viewer) {
      const initialized = await this.initializeViewer();
      if (!initialized) {
        console.error('Viewer failed to initialize.');
        return false;
      }
    }

    // Only call loadModel if the URL exists
    if (svfUrls && svfUrls.option1) {
      return await this.loadModel('option1');
    } else {
      console.warn('SVF URL not available yet.');
      return false;
    }
  },

  async loadModel(option) {
    const svfUrl = svfUrls[option];
    //const viewerDiv = document.getElementById('viewerContainer');
    //const staticImage = document.getElementById('staticImageContainer');
    if (svfUrl) {
      //if (viewerDiv) viewerDiv.style.display = 'flex';
      //if (staticImage) staticImage.style.display = 'none';
      if (viewer) {
        //viewer.unloadModel();
        if (!svfUrl.endsWith('.svf')) {
          console.error('Not a valid SVF file:', svfUrl);
          return false;
        }
        return new Promise((resolve) => {
          viewer.loadModel(
            svfUrl,
            {},
            () => {
              this.onLoadModelSuccess();
              resolve(true);
            },
            (error) => {
              this.onLoadModelError(error);
              resolve(false);
            }
          );
        });
      } else {
        console.error('Viewer is not initialized.');
        return false;
      }
    } else {
      console.error('Invalid model option selected');
      return false;
    }
  },

  onLoadModelSuccess() {
    if (viewer) viewer.fitToView();
  },

  onLoadModelError(error) {
    console.error('Error loading model:', error);
  },

  handleOption(option) {
    const optionMapping = {
      1: [0, 1],
      2: [2, 3],
      3: [4, 5],
      4: [6, 7]
    };
    const [stpIndex, viewableIndex] = optionMapping[option] || [];
    if (stpIndex !== undefined && viewableIndex !== undefined) {
      this.getAndDownloadFiles(stpIndex, viewableIndex);
     // this.setActiveButton(`option${option}`);
    }
  },

  downloadSTP() {
    if (stpUrl) {
      window.location.href = stpUrl;
    } else {
      console.error('No STEP package available for download.');
      this.showToast('No STEP package available for download.', true);
    }
  },
  
  async getAndDownloadFiles(stpIndex, viewableIndex) {
    const origin = window.location && window.location.origin ? window.location.origin : '';
    const url = `${origin}${VAULT_PROXY_BASE}/api/Vault/GetAndDownloadFiles`;
    // Ensure data contains expected items
    if (!Array.isArray(data) || !data[stpIndex] || !data[viewableIndex]) {
      console.warn('ViewerModule: missing file data for requested indices', {
        stpIndex,
        viewableIndex,
        dataLength: Array.isArray(data) ? data.length : -1
      });
      this.showToast('3D assets are not available for this part yet.', true);
      this.setDownloadSTPButtonState(false);
      return;
    }
    const requestData = {
      "FolderFileData": [data[stpIndex], data[viewableIndex]]
    };

    try {
      const response = await axios.post(url, requestData, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: false
      });

      const nullMasterIdFile = response.data.find(file => file.MasterId === null);
      if (nullMasterIdFile) {
        this.showToast(`File '${nullMasterIdFile.FileName}' not found.`, true);
        this.setDownloadSTPButtonState(false);
      } else {
        // Identify files by suffixes rather than positional index
        const files = Array.isArray(response.data) ? response.data : [];
        const viewableZip = files.find(f => typeof f.FileName === 'string' && /_viewable\.zip$/i.test(f.FileName));
        const stepZip = files.find(f => typeof f.FileName === 'string' && /_STEP\.zip$/i.test(f.FileName));

        if (!viewableZip) {
          console.warn('Viewable package not found in response.');
          this.showToast('3D viewable is not available for this part.', true);
        }
        if (!stepZip) {
          console.warn('STEP package not found in response.');
          this.showToast('STEP package is not available for this part.', true);
          this.setDownloadSTPButtonState(false);
        }

        // Assign to the global svfUrls via the proxy path when available
        if (viewableZip && typeof viewableZip.FileName === 'string') {
          svfUrls = {
            option1: `${origin}${VAULT_PROXY_BASE}/VaultFiles/${viewableZip.FileName.replace('_viewable.zip', '')}_viewable/output/1/result.svf`,
            option2: stepZip ? `${origin}${VAULT_PROXY_BASE}/VaultFiles/${stepZip.FileName}` : ''
          };
        } else {
          svfUrls = { option1: '', option2: stepZip ? `${origin}${VAULT_PROXY_BASE}/VaultFiles/${stepZip.FileName}` : '' };
        }

        stpUrl = stepZip ? `${origin}${VAULT_PROXY_BASE}/VaultFiles/${stepZip.FileName}` : '';

        ViewerModule.svfUrls = svfUrls;
        //this.loadModel('option1');
        //this.showToast('Files downloaded and viewer updated successfully.');
        //this.setDownloadSTPButtonState(true);
      }
    } catch (error) {
      console.error('Vault proxy error:', error.response ? error.response.data : error.message);
      this.showToast('Error downloading files. Please try again.', true);
      this.setDownloadSTPButtonState(false);
    }
  },

  setActiveButton(buttonId) {
    if (activeButton) {
      const prevBtn = document.getElementById(activeButton);
      if (prevBtn) prevBtn.classList.remove('active');
    }
    const btn = document.getElementById(buttonId);
    if (btn) btn.classList.add('active');
    activeButton = buttonId;
  },

  setDownloadSTPButtonState(enabled) {
    const downloadSTPButton = document.getElementById('downloadSTP');
    if (!downloadSTPButton) return;
    if (enabled) {
      downloadSTPButton.removeAttribute('disabled');
      downloadSTPButton.classList.remove('inactive');
    } else {
      downloadSTPButton.setAttribute('disabled', 'disabled');
      downloadSTPButton.classList.add('inactive');
    }
  },

  showToast(message, isError = false) {
    const toast = document.createElement('div');
    toast.className = `toast ${isError ? 'error' : 'success'}`;
    toast.textContent = message;
    document.body.appendChild(toast);

    toast.offsetHeight;

    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(20px)';
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 300);
    }, 2000);
  }
};


export default ViewerModule;